<template>
    <div>
        <sub-menu-laudos ativo="amostras"></sub-menu-laudos>

        <posicao-amostras :laudos="true" />
    </div>
</template>

<script>
import SubMenuLaudos from './SubMenuLaudos.vue';
import PosicaoAmostras from '../laboratorio/PosicaoAmostras.vue';

export default {
    components: { 
        SubMenuLaudos,
        PosicaoAmostras,
    },

    mounted() {

        this.$store.commit("setBreadcrumb", [
            { name: "Laudos", path: "/laudos/lista" }, 
            { name: "Amostras", path: "/laudos/amostras" }
        ]);

    },
    
}
</script>

